import {
  BlockWrapper,
  defineBlock,
  ChildrenBlock,
  useEditor,
  smartProps,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import style from "./block.module.scss";
import { EditableHeading, EditableText } from "@smartfire/components";
import { lazy } from "react";

const InspectorLazy = lazy(() => import("./Inspector"));

function Block({ buttonLink, buttonText, buttonBlank, buttonColor, color }) {
  useInspectorControl(InspectorLazy, []);
  const { isEditing } = useEditor();
  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.container}>
        <div className={style.leftColumn}>
          <EditableHeading
            smartProp={"title"}
            placeholder={"Insérer du titre..."}
            className={style.title}
          />
          <EditableText
            tagName={"p"}
            smartProp={"content"}
            placeholder={"Insérer du contenu..."}
            className={style.content}
          />
          <a
            href={!isEditing && buttonLink}
            target={buttonBlank && "_blank"}
            className={style.link}
            style={{
              "--button-color": color,
              "--button-bg-color": buttonColor,
            }}
          >
            {buttonText}
          </a>
        </div>
        <div className={style.rightColumn}>
          <ChildrenBlock
            gutenbergEditorConfig={{
              allowedBlocks: ["smartfire/parallax-columns---item"],
            }}
          />
        </div>
      </div>
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.object.withDefault({
      content: "",
      headingLevel: 2,
    }),
    content: smartProps.string.withDefault(""),
    buttonLink: smartProps.string.withDefault(""),
    buttonText: smartProps.string.withDefault(""),
    buttonLinkType: smartProps.string.withDefault(""),
    buttonBlank: smartProps.bool.withDefault(false),
    buttonColor: smartProps.string.withDefault(""),
    color: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Parallax Columns",
  },
});
